import XAjax from '@ul/ajax';
import XError from '@ul/error';
import {XCodes} from '@ul/message'
import UserInfo from '../model/UserInfo';
import './md5';

const API_VERSION = '1.0'
const API_CHARSET = 'UTF-8';
const ORIGIN_REG = /app|pc$/;
const TOKEN_SNO_KEY='gjzwfwpt@201811!'//调用票据（ticket）
let TIMESTAMP = 0
const API_ORIGIN = {
    PC : 1,
    APP: 2
}
let USER_API = 'https://www.sczwfw.gov.cn/juspace/interface/auth/curMemberCro';


XAjax.config ({
    // https://tftb.sczwfw.gov.cn:8085/api/jmas-api-gateway-server/gateway.do
    // baseURL:'https://www.sczwfw.gov.cn/tftb/api/jmas-api-gateway-server',
    baseURL: 'http://app.gjzwfw.gov.cn/jimps',
    
    // https://tftb.sczwfw.gov.cn:8085/api/jmas-api-gateway-server
    defaultInterceptor: true,

})


/**
 *
 * @param {string} appId 应用ID
 * @param {object} content 请求数据,对象
 * @param {string=} interfaceId 接口ID 如果是数据接口可以不用传,通过ID匹配,非数据接口请传该参数
 * @param {number=} from 来自于PC或者APP,可不传 通过应用ID来匹配
 * @returns {Promise<*>}
 */

export default function loadData (appId, content, interfaceId, from,cb) {

    // content=JSON.stringify(content);
    TIMESTAMP = Date.now ();
    content.from = from
    content.key = interfaceId
    content.appid = appId
    content.requestTime = TIMESTAMP + '';
    content.sign = window.CryptoJS.MD5 (appId + TIMESTAMP).toString ();
    content.gb = 1
    let data = new URLSearchParams();
    data.append ('param', JSON.stringify (content))

    return XAjax.post ('/link.do', data, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'User-Agent'  : 'hanweb',
        }
    }).then (d => {
        if(cb)cb(d)
        if (d.hasOwnProperty ('R')) {//正常请求数据接口
            if (d.R == 200) {
                return d.C
            } else {
                return d
            }
        } else {//请求其他接口,不做处理
            return d
        }
    })
}
export function getTokenSNO (ticket,appid='xszyxwcxapp',key='cef691f217154e40a5557b68e6f50b20') {

    // content=JSON.stringify(content);
    let timestamp = Date.now()+''
    let param = {
        appid,
        key,
        from: '2',
        requestTime: timestamp,
        ticket: ticket,
        // appid + 时间戳  然后md5加密
        sign: CryptoJS.MD5(appid + timestamp).toString(),
    }

    return XAjax.get ('/link.do',  {param: JSON.stringify(param)} ).then (d => {
        if (d.hasOwnProperty ('R')) {//正常请求数据接口
            if (d.R == 200) {
                return d.C
            } else {
                return Promise.reject (d);
            }
        } else {//请求其他接口,不做处理
            if(typeof d=='string')d=JSON.parse(d)
            if(!d.status||d.status !== '0x0000')return new XError(10200,'网络错误',)
            const r=d.data.real
            const data={certNo:r.certNo,userName:r.realName,des_idCard:r.idNumberMaskShow,des_userName:r.realNameMaskShow}
            console.log(data);
            return data
        }
    }).catch(e=>{
        throw new error(e);
        return new XError(10200,'网络错误',)
    })
}
export {API_ORIGIN};
